import styled from '@emotion/styled';
import { Checkbox, Typography } from '@mui/material';

export const StyledPKDCheckbox = styled(Checkbox)(({ theme }) => ({
  padding : '0',
  margin  : '0',
}));

export const StyledCheckboxText = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  fontSize   : '12px',
  lineHeight : '20px',
  color      : theme.palette.primary.gray7,
}));

export const SubHeading = styled(Typography)(({ theme }) => ({
  fontWeight : '700',
  fontSize   : '12px',
  lineHeight : '20px',
  fontFamily : 'Montserrat',
}));
